module.exports = __webpack_public_path__ + "static/xp-bg-207d648213726542f710d2f8680ad29b.png";